module.exports = __webpack_public_path__ + "static/media/HarmonicTriangle.e732795f.pdf";